export function resolveChallengeAdapter(input: {
  production: boolean;
  developmentStaticEnabled: boolean;
}) {
  if (!input.production && input.developmentStaticEnabled) {
    return { mode: "development-static" as const };
  }
  return { mode: "auth-slider" as const };
}
